import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { TokenService } from './token.service';

/**
 * Header key for token
 */
const TOKEN_HEADER_KEY = 'Authorization';

/**
 * Auth Interceptor injectable. Implements HTTP interceptor
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	/**
	 * Auth interceptor constructor
	 *
	 * @param tokenService token service
	 */
	constructor(private tokenService: TokenService) {}

	/**
	 * Gets token, checks if the token is secure and handle the auth request
	 *
	 * @param req auth request
	 * @param next HTTP handler
	 * @returns handled request
	 */
	intercept(req: HttpRequest<any>, next: HttpHandler): any {
		/**
		 * Request token
		 */
		const token = this.tokenService.getToken();
		const headers = new HttpHeaders({
			'ngsw-bypass': '',
			'tenant': this.isBffCall(req.url) ? 'imv' : '',
			'client-id': this.isBffCall(req.url) ? 'imv-ciudadano' : '',
			'Authorization': token && this.isSecureUrl(req.url) ? 'Bearer ' + token : '',
		});
		const clonedReq = req.clone({ headers });
		return next.handle(clonedReq);
	}

	/**
	 * Checks if the request URL is secure
	 *
	 * @param requestUrl request URL
	 * @returns True if the URL is secure
	 */
	private isSecureUrl(requestUrl: string) {
		if (this.tokenService.isCaiss()) {
			return true;
		}

		const privateUrls: string[] = ['/solicitud', '/validacion-email', '/expediente', '/documento'];
		const publicUrls: string[] = ['/validarEmail'];

		const isPrivate = privateUrls.some(url => requestUrl.indexOf(url) !== -1);
		const isPublic = publicUrls.length > 0 ? publicUrls.some(url => requestUrl.indexOf(url) !== -1) : false;
		return isPrivate && !isPublic;
	}

	/**
	 * Checks if the call is bff
	 *
	 * @param requestUrl request URL
	 * @returns true if the call is bff
	 */
	private isBffCall(requestUrl: string): boolean {
		return /\/bff\//.test(requestUrl) || /\/bff-caiss\//.test(requestUrl);
	}
}
